import styled from 'styled-components';

export const TransactionsContainer = styled.div`
  background: ${({ theme }) => theme.colors.white};
  border-bottom: 1px solid ${({ theme }) => theme.colors.grey003};
  box-shadow: 0px 2px 4px rgba(${({ theme }) => theme.colors.rgb.blue8PercentOpacity});
  border-radius: 8px;
  min-height: 450px;
  text-transform: capitalize;
`;
